import { useState, useEffect, useCallback, useRef } from 'react';
import maintenanceSalaryCombinationV2Service from '../services/maintenanceSalaryCombinationV2';
import { useEnumsApi } from './useEnumsApi';
import { FEATURES } from '../../config/features';

export const useSalaryRateMatcher = (formState, salaryType, keyMap) => {
  const [matchedRules, setMatchedRules] = useState([]);
  const [loading, setLoading] = useState(false);
  const { maintenanceTypes } = useEnumsApi();
  const lastPayloadRef = useRef("");

  const fetchMatchedRules = useCallback(async () => {
    // Only fetch for the specific Salary Combination type
    if (salaryType !== "MaintenanceSalaryCombination") {
      if (matchedRules.length > 0) setMatchedRules([]);
      return;
    }

    if (!maintenanceTypes || maintenanceTypes.length === 0) return;

    const requiredFilters = FEATURES.MAINTENANCE_SALARY_FILTERS;
    const apiPayload = [];

    for (const filterKey of requiredFilters) {
      const stateKey = keyMap[filterKey];
      const value = formState[stateKey];
      const typeInfo = maintenanceTypes.find(t => t.name === filterKey);

      if (value && typeInfo) {
        apiPayload.push({ type: typeInfo.value, value: parseInt(value) });
      }
    }

    const currentPayloadString = JSON.stringify(apiPayload);

    if (apiPayload.length === requiredFilters.length && apiPayload.length > 0) {
      if (currentPayloadString === lastPayloadRef.current) return;

      setLoading(true);
      lastPayloadRef.current = currentPayloadString;

      try {
        const res = await maintenanceSalaryCombinationV2Service.getDashboard(apiPayload);
        setMatchedRules(res.data.rules || []);
      } catch (err) {
        setMatchedRules([]);
      } finally {
        setLoading(false);
      }
    } else {
      setMatchedRules([]);
      lastPayloadRef.current = "";
    }
    // Deep watch the relevant form values
  }, [salaryType, maintenanceTypes, JSON.stringify(formState), keyMap]);

  useEffect(() => {
    fetchMatchedRules();
  }, [fetchMatchedRules]);

  return { matchedRules, loading };
};